'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window'];
angular.module('kerp-forms.forms').factory('WF_FCA_SCHEMA', schema);
